const removeAllButFirstTableOfContents = () => {
  const tableOfContents = document.querySelectorAll( '.table-of-contents' );
  if (tableOfContents.length > 1) {
    for (let i = 1; i < tableOfContents.length; i++) {
      tableOfContents[i].remove();
    }
  }
}

const initTableOfContents = () => {
  const mainContent = document.getElementById( 'main-content' );
  const tableOfContents = document.querySelector( '.table-of-contents' );
  if (!tableOfContents) return;

  const headings = mainContent.querySelectorAll( 'h2:not(.table-of-contents__title)' );

  const filteredHeadings = Array.from( headings ).filter( heading => {
    return !heading.closest( '.accordion__content' );
  } );

  if (filteredHeadings.length === 0) {
    tableOfContents.remove();
    return;
  }

  filteredHeadings.forEach( heading => {
    const link = document.createElement( 'a' );
    if (!heading.id) {
      heading.id = `h-${Math.random().toString( 36 ).substr( 2, 9 )}`;
    }
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent;
    const listItem = document.createElement( 'li' );
    listItem.appendChild( link );
    tableOfContents.querySelector( 'ul' ).appendChild( listItem );
  } );
}

const init = () => {
  removeAllButFirstTableOfContents();
  initTableOfContents();
}

export default init;
